module.exports = __webpack_public_path__ + "static/img/logo_cgm.44a9cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/logo_cgm.png
// module id = IBWA
// module chunks = 0